/** Path pattern for QR payloads generated by qrConnect (self_test session links). */
const SELF_TEST_PATH = /^\/self_test\/[^/]+\/[^/]+\/(?:integration|global)\/[^/]+\/[^/]+$/;

// Extracts pathname from a full URL or path string for validation.
function pathnameFromQrPayload(raw: string): string {
  const trimmed = raw.trim().split(/[?#]/)[0];
  if (!trimmed) {
    return '';
  }
  if (/^https?:\/\//i.test(trimmed)) {
    try {
      return new URL(trimmed).pathname.replace(/\/+$/, '') || '/';
    } catch {
      return '';
    }
  }
  const path = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  return path.replace(/\/+$/, '') || '/';
}

// Returns the self-test pathname if the QR payload matches the expected route; otherwise null.
export function getSelfTestPathFromQrPayload(raw: string): string | null {
  const path = pathnameFromQrPayload(raw);
  if (!path) {
    return null;
  }
  return SELF_TEST_PATH.test(path) ? path : null;
}
